export function cleanUrlParam(param) {
    //Custom delimiter for '/' that  needs to be replaced server-side
    param = param.replace("/", "|*|");

    param = encodeURIComponent(param);
    
    return param;
}